import { Component, OnInit, Inject } from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import * as Moment from 'moment';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatSelect } from '@angular/material';
@Component({
  selector: 'app-adjust-periode-pajak',
  templateUrl: './adjust-periode-pajak.component.html',
  styleUrls: ['./adjust-periode-pajak.component.css']
})
export class AdjustPeriodePajakComponent implements OnInit {

  private periodepajaks: PeriodePajak[] = [];
  selectedOption: PeriodePajak;

  constructor(
    private dialogRef: MatDialogRef<AdjustPeriodePajakComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    const date: Date = this.data.tanggal_faktur;
    let startDate = Moment(date);
    const endDate = Moment(date).add(Moment.duration(60, 'd'));
    const datebetween: Date[] = [];
    while (startDate.toDate() <= endDate.toDate()) {
      datebetween.push(startDate.toDate());
      startDate = startDate.add(1, 'd');
    }
    datebetween.forEach(d => {
      const pp = PeriodePajak.PeriodePajakFromDate(d);
      const index = this.periodepajaks.findIndex(a => a.isEqual(pp));
      if (index < 0) {
        // none found
        this.periodepajaks.push(pp);
      }
    });
    this.selectedOption = this.periodepajaks[0];
  }

  update() {
    this.dialogRef.close(this.selectedOption);
  }

  close() {
    this.dialogRef.close();
  }
}

export class PeriodePajak {
  month: number;
  year: number;

  static PeriodePajakFromDate(date: Date): PeriodePajak {
    const pp = new PeriodePajak();
    pp.month = date.getMonth() + 1;
    pp.year = date.getFullYear();
    return pp;
  }

  isEqual(pp: PeriodePajak): boolean {
    return this.month === pp.month && this.year === pp.year;
  }

  toString(): string {
    return this.month.toString() + '/' + this.year.toString();
  }
}



// WEBPACK FOOTER //
// ./src/app/faktur-pajak-masukan/adjust-periode-pajak/adjust-periode-pajak.component.ts